/**
 * Размер файла по-русски: шкала 1024, единицы Б/КБ/МБ/ГБ/ТБ, дробная часть —
 * через запятую (интерфейс админки русский). Одна функция на всю админку:
 * вложения писем, медиатека «Запусков FB».
 *
 *   bytesToHuman(null)      -> ''
 *   bytesToHuman(0)         -> '0 Б'
 *   bytesToHuman(512)       -> '512 Б'
 *   bytesToHuman(2048)      -> '2 КБ'
 *   bytesToHuman(1536)      -> '1,5 КБ'
 *   bytesToHuman(5_000_000) -> '4,77 МБ'
 */
export function bytesToHuman(n) {
    if (n == null || Number.isNaN(n))
        return '';
    if (n < 1024)
        return `${n} Б`;
    const units = ['КБ', 'МБ', 'ГБ', 'ТБ'];
    let value = n / 1024;
    let idx = 0;
    while (value >= 1024 && idx < units.length - 1) {
        value /= 1024;
        idx++;
    }
    // Trim trailing zero when the value lands on a round number.
    const rounded = value >= 100 ? Math.round(value) : Number(value.toFixed(value >= 10 ? 1 : 2));
    return `${String(rounded).replace('.', ',')} ${units[idx]}`;
}
//# sourceMappingURL=format-bytes.js.map